import { WarningIcon } from '@phosphor-icons/react';

import { Alert } from '@/ui/Alert';
import { ApiError } from '@/utils/fetch.client';

import { StaffDetails } from './StaffDetails';

/**
 * A failed read of one of the git endpoints. Every one of them resolves through the sandbox, so
 * the failures that matter here — a stopped sandbox, an expired provider token — are exactly the
 * ones the old silent empty state hid behind "no changes yet".
 */
export function RequestError({ error, what }: { error: unknown; what: string }) {
  const api = error instanceof ApiError ? error : null;
  const message = api?.message ?? (error instanceof Error ? error.message : 'Unknown error');

  return (
    <Alert
      variant="danger"
      title={`Could not load ${what}`}
      icon={<WarningIcon size={14} />}
      className="m-3 p-3 text-xs"
    >
      <p className="text-fg-secondary">{message}</p>
      <StaffDetails details={api?.details} />
    </Alert>
  );
}
